import { SET_REMEMBER_ME, CLEAR_REMEMBER_ME } from "../actions/action";

const defaultState = {
  isRememberMe: false,
  email: null,
  password: null,
};

const rememberMeReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_REMEMBER_ME:
      return { ...state, isRememberMe: true, email: action.payload.email, password: action.payload.password };
    case CLEAR_REMEMBER_ME:
      return { ...state, isRememberMe: false, email: null, password: null };
    default:
      return state;
  }
};

export default rememberMeReducer;
